import { createFileRoute, redirect } from "@tanstack/react-router";

// The audit log moved to Console; an old link lands on the applications list.
export const Route = createFileRoute("/audit")({
	beforeLoad: () => {
		throw redirect({
			to: "/applications",
			search: {
				search: "",
				startDate: "",
				endDate: "",
				page: 1,
				filterStatus: "",
				filters: {},
				tab: "single",
			},
			replace: true,
		});
	},
});
